import { MapPin } from "@phosphor-icons/react";
import { useSiteContent } from "../../contexts/SiteContentContext";
import { DEFAULT_SITE_CONTENT } from "../../lib/siteContentDefaults";

export default function MapSection() {
  const c = { ...DEFAULT_SITE_CONTENT, ...useSiteContent() };
  const ZONES = [c.service_area_badge_1, c.service_area_badge_2, c.service_area_badge_3, c.service_area_badge_4];
  return (
    <section id="locations" className="py-24 px-6 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-[0.9fr_1.1fr] gap-10 items-center">
        <div>
          <p className="font-heading uppercase tracking-[0.2em] text-xs text-[#D4AF37] mb-2">Service Area</p>
          <h2 data-testid="service-area-title" className="font-heading text-3xl sm:text-4xl md:text-5xl text-white tracking-tight mb-6">{c.service_area_title}</h2>
          <p data-testid="service-area-body" className="text-[#A1A1AA] mb-8 leading-relaxed">
            {c.service_area_body}
          </p>
          <div className="grid grid-cols-2 gap-3">
            {ZONES.map((z, i) => (
              <div key={i} data-testid={`service-zone-${i}`} className="flex items-center gap-2 border border-[#27272A] rounded-xl px-4 py-3 text-sm text-white">
                <MapPin size={16} weight="fill" className="text-[#D4AF37] shrink-0" /> {z}
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-2xl overflow-hidden border border-[#27272A] h-[380px]">
          <iframe
            data-testid="bay-area-map-embed"
            title="Exist Fit Bay Area Service Zones"
            src="https://www.google.com/maps?q=San+Francisco+Bay+Area&output=embed"
            className="w-full h-full"
            style={{ filter: "invert(92%) hue-rotate(180deg)" }}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
